import SsoPage from './SsoPage';

export default SsoPage;
